module.exports = __webpack_public_path__ + "static/img/do.1ace9613.svg";